/**
 * Created by sarimj on 2/1/2016.
 */
/// <reference path="../../../app.definition.ts" />

// typescript namespace
import angular from "angular";
export class TeamRolePopUpController {
    teamRoles;

    static $inject = ["PopUpService", "ApiAdapterService", "$uibModalInstance", "NgTableParams", "Subject", "TeamRoleService"];

    constructor(PopUpService, ApiAdapterService, $uibModalInstance, NgTableParams, Subject,
        private $_teamRoleService: eCareVault.ITeamRoleService) {
        var teamRolePopUpVm = this;
        teamRolePopUpVm.editingRoleId = 0;
        teamRolePopUpVm.subject = Subject;

        teamRolePopUpVm.cancel = function () {
            $uibModalInstance.dismiss();
        };

        teamRolePopUpVm.dismiss = () => {
            $uibModalInstance.dismiss();
        }

        teamRolePopUpVm.add = (roleName) => {
            if (!roleName) {
                PopUpService.openInformationModal('Team role cannot be empty.');
                return;
            } else if (roleName.length > 50) {
                PopUpService.openInformationModal('Team role cannot be greater than 50 words.');
                return;
            }

            teamRolePopUpVm.loader = 'Adding Team Role';
            //ApiAdapterService.addTeamRole(teamRolePopUpVm.roleName, PopUpService.data.subject.subjectId ).then((s) => {
            ApiAdapterService.addTeamRole(teamRolePopUpVm.roleName, Subject.subjectId).then((s) => {

                teamRolePopUpVm.loader = false;
                $uibModalInstance.close({ teamRoles: s.filter((tr) => tr.id != -1), newAdded: roleName });

            }, (e) => {
                //later
                PopUpService.openInformationModal(e);
                teamRolePopUpVm.loader = false;

            });
        };

        //remove editing field
        teamRolePopUpVm.cancelEdit = () => {
            customRoles.forEach((a) => {
                if (a.id == teamRolePopUpVm.editingRoleId) {
                    a.roleName = teamRolePopUpVm.teamRoles.find(b => b.id == teamRolePopUpVm.editingRoleId).roleName;
                }
            });
            teamRolePopUpVm.editingRoleId = 0;
        }

        //show editing field
        teamRolePopUpVm.edit = (role) => {

            if (teamRolePopUpVm.editingRoleId) {
                customRoles.forEach((a) => { if (a.id == teamRolePopUpVm.editingRoleId) { a.roleName = teamRolePopUpVm.teamRoles.find(b => b.id == teamRolePopUpVm.editingRoleId).roleName; } });
            }
            teamRolePopUpVm.editingRoleId = role.id;
        }

        //update the team role
        teamRolePopUpVm.update = (role) => {

            if (!role.roleName) {
                PopUpService.openInformationModal('Team role cannot be empty.');
                return;
            } else if (role.roleName.length > 50) {
                PopUpService.openInformationModal('Team role cannot be greater than 50 words.');
                return;
            }

            teamRolePopUpVm.loader = 'Updating Team Role';

            ApiAdapterService.updateTeamRole(role.roleName, Subject.subjectId, role.id).then(
                (s) => {
                    teamRolePopUpVm.loader = false;

                    teamRolePopUpVm.teamRoles.forEach((a) => { if (a.id == role.id) a.roleName = role.roleName });
                    teamRolePopUpVm.teamRoles = s;
                    PopUpService.data.teamRoles = s;

                    teamRolePopUpVm.cancelEdit();
                    teamRolePopUpVm.editingRoleId = 0;
                    toastr.success('Team role updated.');
                },
                e => {
                    PopUpService.openInformationModal(e);
                    teamRolePopUpVm.loader = false;
                })
        }


        //Filter the custom roles for this subject
        var customRoles = [];
        this.$_teamRoleService.getTeamRoles(teamRolePopUpVm.subject.subjectTypeId).then((s) => {
            teamRolePopUpVm.teamRoles = s;
            angular.copy(teamRolePopUpVm.teamRoles.filter((a) => !!a.addedBy), customRoles);

            teamRolePopUpVm.tableParams = new NgTableParams(
                {
                    count: 10,
                    sorting: {
                        age: 'desc'
                    }
                },
                {
                    counts: [],
                    data: customRoles

                }
            );
        });



    }
}


angular.module('eCareVault.common.popUp')
    .controller('TeamRolePopUpController', TeamRolePopUpController);
